"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerGlobal = exports.getGlobal = void 0;
const LOGGING_API_KEY = Symbol.for('@mirohq-internal/telemetry-logging');
const _global = globalThis;
const getGlobal = (type) => {
    var _a;
    return (_a = _global[LOGGING_API_KEY]) === null || _a === void 0 ? void 0 : _a[type];
};
exports.getGlobal = getGlobal;
const registerGlobal = (type, instance) => {
    _global[LOGGING_API_KEY] = _global[LOGGING_API_KEY] || {};
    _global[LOGGING_API_KEY][type] = instance;
};
exports.registerGlobal = registerGlobal;
//# sourceMappingURL=global.js.map